// Module
var code = "<div class=\"geosearch\">\n\t<button type=\"button\" class=\"geosearch__button\" rv-title=\"'geoSearch.locate' | string\" rv-on-click=\"view.locate\"></button>\n\t<label class=\"geosearch__field\">\n\t\t<input type=\"text\" rv-placeholder=\"'geoSearch.placeholder' | string\" class=\"geosearch__input\" value=\"\">\n\t</label>\n</div>\n";
// Exports
module.exports = code;